import React from 'react';
import cn from 'classnames';
import s from './Loader.scss';
var Loader = function (_a) {
    var type = _a.type;
    return (React.createElement("div", { className: cn(s['root'], type === 'drawer-suspense' && s['drawer-suspense'], type === 'drawer' && s['drawer'], type === 'feed' && s['feed']) },
        React.createElement("div", { className: s['box'] }),
        React.createElement("div", { className: s['box'] }),
        React.createElement("div", { className: s['box'] })));
};
Loader.displayName = 'Loader';
export default Loader;
//# sourceMappingURL=Loader.js.map